import React from 'react';
import {
    RichCell,
    PanelHeader,
    Cell,
    PanelHeaderButton,
    Div,
    SplitCol,
    SplitLayout,
    Button,
    Switch, Spinner, Pagination, Search, Alert, NativeSelect, SimpleCell
} from '@vkontakte/vkui';
import axios from "axios";
import {addDays} from "@vkontakte/vkui/dist/lib/date";
import {
    AdaptivityContext, inducement
} from "../assets/constants";
import moment from "moment";
import DateRangePicker from '@wojtekmaj/react-daterange-picker'
import * as constants from "../assets/constants";
import {
    Icon20EditCircleFillBlue,
    Icon24ExpositionOutline,
    Icon24PicturePlusOutline, Icon24Refresh,
    Icon24Search
} from "@vkontakte/icons";
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';

import BaseComponent from "../components/BaseComponent";
import BaseApi from "../api/BaseApi";
import IncomingDocsViewer from "../incoming/IncomingDocsViewer";
import CopyToClipBoard from "../assets/CopyToClipboardButton";


class FacingMonitoringDocs extends BaseComponent {

    state = {
        value: [addDays(new Date(), -90), new Date()],
        items: [],
        selected_items: {},
        showDocsAlert: false,
        dateRangeIsOpen: false,
        cnt_items: 0,
        loading: true,
        show_all_divisions: true,
        show_sub_docs: false,
        is_slice: false,
        currentDocId: null,
        append: false,
        page: 1,
        totalPages: 1,
        mainSearch: '',
        showSearch: false,
        currentStatus: '',
        currentType: '',
        ids: [],
        labels: {},
        typeslabels: {},
    }

    constructor(props) {


        super(props);

        const ids = this.loadValues()
        if (ids && Array.isArray(ids) && ids.length > 0 && !this.props.current_doc) {
            this.state.showDocsAlert = true
        }
        this.state.labels = constants.getFacingMonitoringStatuses()
        this.state.typeslabels = constants.getFacingMonitoringTypes()
    }

    loadValues = () => {
        const data = localStorage.getItem(constants.values_facing_monitoring_key)

        //  console.log(data)
        if (data && data !== "undefined") {
            const items = JSON.parse(data)


            const ids = Object.keys(items).sort((a, b) => items[b].sort - items[a].sort)

            return ids;
        }
        return false
    }
    dateChange = (e) => {
        console.log(e)
        this.setState({dateRangeIsOpen: false, loading: true, value: e, page: 1, items: []})

        setTimeout(() =>
            this.getItems(), 700)
    }
    changeCurrentStatus = (status) => {

        this.setState({loading: true, currentStatus: status, page: 1, items: []})
        setTimeout(() =>
            this.getItems(), 700)
    }

    changeCurrentType = (type_) => {

        this.setState({loading: true, currentType: type_, page: 1, items: []})
        setTimeout(() =>
            this.getItems(), 700)
    }

    getItems = (mainSearch = '', append, page) => {
        clearInterval(this.searchInterval);
        append = append == undefined ? false : append
        if (page == undefined) {
            page = this.state.page;
        }
        if (mainSearch == undefined) {
            mainSearch = this.state.mainSearch
        }
        const currentStatus = this.state.currentStatus

        const currentType = this.state.currentType

        this.setState({loading: true, cnt_items: ''})
        const body = new FormData()
        body.append('sSearch', mainSearch)
        body.append('page', page)
        if (currentStatus) {
            body.append('status', currentStatus)
        }

        if (currentType) {
            body.append('type', currentType)
        }
        if (!this.state.show_all_divisions && this.props.current_user.meta.division && this.props.current_user.meta.division.code) {
            body.append('division', this.props.current_user.meta.division.code)
        }
        if (this.state.is_slice) {
            body.append('is_slice', 1)
        }

        body.append('start', this.state.value[0].toLocaleDateString())
        body.append('end', this.state.value[1].toLocaleDateString())
        body.append('epp', AdaptivityContext.isMobile ? 10 : (this.props.is_firm_fit ? 5 : 8))
        body.append('show_sub_docs', this.state.show_sub_docs === true ? 1 : 0)

        if (!append) {
            this.setState({items: []})
        }
        axios.post(this.props.base_url + '?app=facingMonitoring&act=showManyJson2', body,
            {
                withCredentials: true

            }
        ).then((response) => {
            this.setState({loading: false})
            let old = this.state.items;
            if (!append) {
                old = response.data.results
            } else {
                response.data.results.map((el, i) => {
                    old.push(el)
                })
            }

            this.setState({items: old})


            this.setState({cnt_items: response.data.iTotalRecords})
            this.setState({totalPages: response.data.iTotalPages})

            if (response.data.iTotalPages * 1 > 0) {
                setTimeout(() => {
                    this.checkScroll()
                }, 500)
            }
        })

    }

    receiveMessage = (event) => {

        if (event.data.type != undefined) {

        }

    }
    scrollPrev = 0
    checkScroll = () => {

        if (AdaptivityContext.isMobile) {
            let headerMobStorage = document.getElementsByClassName('mobile-table-storage-header')

            if (!headerMobStorage || headerMobStorage.length === 0) return

            headerMobStorage = headerMobStorage[0]
            const scrolled = window.scrollY

            if (scrolled > 100 && scrolled > this.scrollPrev) {
                headerMobStorage.classList.add('out')
            } else {
                headerMobStorage.classList.remove('out')
            }
            this.scrollPrev = scrolled
        }

        if (!this.ref.current) return
        if (this.state.cnt_items * 1 <= this.state.items.length) return
        let visible = this.ref.current.getBoundingClientRect().top < window.innerHeight - 50;

        if (!this.state.loading && visible) {
            let page = this.state.page
            if (page >= this.state.totalPages * 1) return
            page++;
            this.setState({page: page})

            this.getItems(undefined, true, page)


        }
    }

    handleScroll() {
        this.checkScroll()
    }

    componentDidMount = () => {

        moment.locale('ru')


        this.getItems()
        const ids = this.loadValues()
        this.setState({ids})
        super.componentDidMount()


    }


    setPage = (page) => {
        if (page <= this.state.totalPages) {
            this.setState({loading: true, page: page})
            setTimeout(() =>
                this.getItems(this.state.mainSearch, false, page), 600)
        }
    }

    toggleSearch = () => {


        this.setState({showSearch: !this.state.showSearch});

    }

    searchInterval = null;
    element = null;
    onSearchChange = (state) => {


        clearInterval(this.searchInterval);
        this.setState({mainSearch: state.target.value});
        this.searchInterval = setInterval(() => {
            // console.log(state);
            this.setState({loading: true, page: 1});
            this.getItems(this.state.mainSearch, false, 1);
        }, state.target.value == '' ? 500 : 2000);

    }

    getDoc = (item) => {


        BaseApi.get(`?app=FacingMonitoring&act=getOne&doc_id=${item.id}`,
        ).then((response) => {

            if (response.data.doc_data) {
                this.props.select_doc(response.data)
                localStorage.setItem(constants.values_facing_monitoring_key, JSON.stringify(response.data.items_values))
                window.postMessage({type: 'editFacingMonitoring'})
            }


        })

    }

    export2Csv = () => {

        const {selected_items, currentStatus} = this.state

        let ids = ''

        if (Object.keys(selected_items).length > 0) {
            ids = Object.keys(selected_items).join(',')
        }

        const ajaxSrc = this.props.base_url + "/?app=FacingMonitoring&act=showManyJson2&start=" + this.state.value[0].toLocaleDateString() +
            "&end=" + this.state.value[1].toLocaleDateString() +
            '&sSearch=' +
            '&docs_ids=' + ids +
            '&status=' + currentStatus +
            '&show_sub_docs=' + (this.state.show_sub_docs === true ? 1 : 0) +
            '&is_slice=' + (this.state.is_slice === true ? 1 : 0) +
            '&export_excel=1' +
            '&page=' + 1;

        window.open(ajaxSrc, 'blank_');
    }

    render() {

        const is_moder = constants.checkIsModer(this.props.current_user)
        const alertDocs = <Alert
            onClose={() => this.setState({showDocsAlert: false})}
            actionsAlign="left"
            actionsLayout="horizontal"
            actions={[
                {
                    title: 'Продолжить',
                    action: () => {
                        this.startFacingMonitoring(true)


                        this.setState({showDocsAlert: false, page: 1});
                        setTimeout(() => this.getItems('', false, 1), 500)
                    },

                },
                {
                    title: 'Создать новую',
                    action: () => {

                        this.startFacingMonitoring()


                        this.setState({showDocsAlert: false, page: 1});

                        setTimeout(() => this.getItems('', false, 1), 500)
                    },
                },
            ]}

            header="Обнаружена не завершённая инвентаризация"
            text={"Продолжить заполнение или создать новый документ? Все не отправленные в 1С данные будут потеряны!"}
        />
        return (
            <SplitLayout popout={this.state.showDocsAlert ? alertDocs : null}>
                <SplitCol>
                    <PanelHeader fixed={true}
                                 before={AdaptivityContext.isMobile ?
                                     <PanelHeaderButton style={{display: 'inline'}}
                                                        onClick={this.toggleSearch}><Icon24Search/></PanelHeaderButton> : ''}
                                 after={!this.state.showSearch || !AdaptivityContext.isMobile ?
                                     <Div style={{display: "flex"}}>
                                         <DateRangePicker
                                             onCalendarClose={() => setTimeout(() => this.setState({dateRangeIsOpen: false}), 1000)}
                                             onClick={() => {
                                                 this.setState({dateRangeIsOpen: true});
                                             }}
                                             showLeadingZeros={true}
                                             value={this.state.value}
                                             isOpen={this.state.dateRangeIsOpen}
                                             key="SaleDocsDateRangePicker"
                                             onChange={this.dateChange}/>
                                         <Button size="s" mode="tertiary" style={{maxWidth: "42px"}} onClick={() => {
                                             this.setState({page: 1, items: []});
                                             this.getItems(this.state.mainSearch, false, 1)
                                         }}><Icon24Refresh/></Button>
                                     </Div> : ''}
                    >
                        <Div>
                            {this.state.showSearch || !AdaptivityContext.isMobile ?
                                <Search autoFocus

                                        theme="header"
                                        placeholder="Поиск"
                                        value={this.state.mainSearch}
                                        onChange={this.onSearchChange}
                                        onClose={this.toggleSearch}

                                        style={{flexGrow: '1', maxWidth: '350px'}}
                                /> : AdaptivityContext.isMobile ? '' : ''

                            }

                        </Div>
                    </PanelHeader>
                    <div
                        className={AdaptivityContext.isMobile || true ? 'mobile-table-storage-header' : 'desktop-table-storage-header'}>
                        <SplitLayout>
                            <SplitCol>
                                <Button before={<Icon24PicturePlusOutline/>}
                                        onClick={() => (this.state.ids && this.state.ids.length > 0 && !this.props.current_doc) ? this.setState({showDocsAlert: true}) : this.startFacingMonitoring()}
                                        mode="primary" size="l">
                                    Начать инвентаризацию витрины
                                </Button>

                                {!AdaptivityContext.isMobile && <Button before={<Icon24ExpositionOutline/>}
                                                                        mode="primary" size="l"
                                                                        onClick={() => this.export2Csv()}>Экспорт в
                                    Excel</Button>}
                            </SplitCol>

                            {(!AdaptivityContext.isMobile) && [
                                (!is_moder ? <SplitCol style={{maxWidth: '150px'}}>
                                        <SimpleCell Component="label" multiline
                                                    after={<Switch size={5} checked={this.state.show_all_divisions}
                                                                   onChange={this.setShowAllDivisions}/>}>
                                            Показывать не свои подразделения
                                        </SimpleCell>
                                    </SplitCol> :
                                    <SplitCol style={{maxWidth: '150px'}}>
                                        <SimpleCell Component="label" multiline className="docs-switcher"
                                                    after={<Switch size={5} checked={this.state.show_sub_docs}
                                                                   onChange={this.setShowSubDocs}/>}>
                                            Показывать не свои документы
                                        </SimpleCell>
                                    </SplitCol>),
                                <SplitCol style={{maxWidth: '150px'}}>
                                    <SimpleCell Component="label" multiline className="docs-switcher"
                                                after={<Switch size={5} checked={this.state.is_slice}
                                                               onChange={this.setIsSlice}/>}>
                                        Срез
                                    </SimpleCell>

                                </SplitCol>]}
                            <SplitCol>
                                <Div className="all-docs-block">

                                <span className="all-docs" id="status" style={{height: '30px'}}>
                                <NativeSelect
                                    style={{
                                        zIndex: 6,
                                        marginLeft: '10px',
                                        height: '30px',
                                        maxWidth: AdaptivityContext.isMobile && this.props.monitoring_mode ? '150px' : 'inherit'
                                    }}
                                    value={this.state.currentStatus}
                                    onChange={(e) => this.changeCurrentStatus(e.target.value)}
                                >
                                    {Object.keys(this.state.labels).map((itemP, indexP) => (
                                        <option value={itemP}>{this.state.labels[itemP]}</option>
                                    ))}</NativeSelect>
                                </span>

                                    <span className="all-docs" id="types" style={{height: '30px'}}>
                                <NativeSelect
                                    style={{
                                        zIndex: 6,
                                        marginLeft: '10px',
                                        height: '30px',
                                        maxWidth: AdaptivityContext.isMobile && this.props.monitoring_mode ? '150px' : 'inherit'
                                    }}
                                    value={this.state.currentType}
                                    onChange={(e) => this.changeCurrentType(e.target.value)}
                                >
                                    {Object.keys(this.state.typeslabels).map((itemP, indexP) => (
                                        <option value={itemP}>{this.state.typeslabels[itemP]}</option>
                                    ))}</NativeSelect>
                                </span>
                                    <span className="all-docs"
                                          id="cnt_items">Всего документов: {this.state.cnt_items}</span>
                                </Div>
                            </SplitCol>
                        </SplitLayout>

                        {AdaptivityContext.isMobile && <SplitLayout>
                            {!is_moder ? <SplitCol style={{maxWidth: '150px'}}>
                                    <SimpleCell Component="label" multiline
                                                after={<Switch size={5} checked={this.state.show_all_divisions}
                                                               onChange={this.setShowAllDivisions}/>}>
                                        Показывать не свои подразделения
                                    </SimpleCell>
                                </SplitCol> :
                                <SplitCol style={{maxWidth: '150px'}}>
                                    <SimpleCell Component="label" multiline className="docs-switcher"
                                                after={<Switch size={5} checked={this.state.show_sub_docs}
                                                               onChange={this.setShowSubDocs}/>}>
                                        Показывать не свои документы
                                    </SimpleCell>
                                </SplitCol>}
                            <SplitCol style={{maxWidth: '150px'}}>
                                <SimpleCell Component="label" multiline
                                            after={<Switch size={5} checked={this.state.is_slice}
                                                           onChange={this.setIsSlice}/>}>
                                    Срез
                                </SimpleCell>
                            </SplitCol>
                        </SplitLayout>}
                    </div>

                    {!this.state.show_all_divisions && this.props.current_user.meta && this.props.current_user.meta.division && this.props.current_user.meta.division.code &&
                        <Div>
                            <small>Подразделение: <b>{this.props.current_user.meta.division.name}</b></small>
                        </Div>}
                    {!this.state.loading && Array.isArray(this.state.items)
                        && this.state.items.length === 0 && <Cell key={'notFound' + 0}>Ничего не найдено</Cell>}
                    {this.state.items.map((item, index) => {
                        let statusBackground = 'inherit'
                        /*

                                                if (item.statusDoc == constants.CODE_FACING_MONITORING_STATUS_IN_PROCESS) {
                                                    statusBackground = yellowBG
                                                }
                                                if (item.statusDoc == constants.CODE_FACING_MONITORING_STATUS_SENT) {
                                                    statusBackground = greenBG
                                                }
                        */

                        let statusDoc = ''

                        statusDoc = `Статус: ${this.state.labels[item.status]}`

                        let typeDoc = ''

                        typeDoc = `Тип: ${this.state.typeslabels[item.type_]}`

                        return [<SplitLayout>
                            <SplitCol>
                                <RichCell

                                    before={!AdaptivityContext.isMobile &&
                                        <Switch
                                            checked={this.state.selected_items[item.id] === true}
                                            size="l"
                                            onChange={e => this.setSelected(e, index)}/>}
                                    style={{
                                        background: statusBackground
                                    }}
                                    subhead={[item.date + ' ' + item.time, ' ', <strong>{typeDoc}</strong>]}
                                    bottom={<div style={{display: "flex", justifyContent: "space-between"}}>
                                        <strong>{statusDoc}</strong>
                                        <span style={{maxWidth: "70%", textAlign: "right"}}>{item.comment}</span>
                                    </div>}
                                    caption={<div style={{display: "flex", flexDirection: "column"}}>
                                        <strong>{item.user.name}</strong>
                                        <span>{item.division_name ? item.division_name : 'Без подразделения'}</span>
                                    </div>}
                                    afterCaption={<div style={{display: "flex", flexDirection: "column"}}>
                                        <span>{[item.items_cnt, ' ', inducement(item.items_cnt, 'позиция', 'позиции', 'позиций')]}</span>
                                        <Button mode="outline" size="m"
                                                onClick={() => this.getDoc(item)}><Icon20EditCircleFillBlue/></Button>
                                    </div>
                                    }>

                                    {item.nomer ? [item.nomer,
                                        <CopyToClipBoard style={{marginTop: '0px', minWidth: '36px'}}
                                                         text={item.nomer}/>] : 'Номер в 1С еще не получен'}
                                </RichCell>
                            </SplitCol>
                        </SplitLayout>,

                            <hr/>]
                    })}
                    {AdaptivityContext.isMobile || true ?
                        <div ref={this.ref} key="loader" style={{height: '50px', width: 'auto'}}>{this.state.loading ?
                            <Cell before="Запрашиваем данные с сервера"
                                  after={<Spinner size="large"/>}></Cell> : ""}</div> : this.state.loading ?
                            <Cell before="Запрашиваем данные с сервера" after={<Spinner size="large"/>}></Cell> : ""}
                    {this.state.totalPages > 1 && !AdaptivityContext.isMobile ?
                        <div style={{background: "whitesmoke", position: "fixed", bottom: "52px", zIndex: '99'}}>
                            <Pagination currentPage={this.state.page}
                                        totalPages={this.state.totalPages}
                                        onChange={this.setPage}/>
                        </div> : ''}
                </SplitCol>
            </SplitLayout>
        )
    }

    setSelected = (e, index) => {
        const item = this.state.items[index]
        if (item) {
            const olds = this.state.selected_items
            olds[item.id] = e.currentTarget.checked

            if (!e.currentTarget.checked) {
                delete olds[item.id]
            }

            this.setState({selected_items: olds})
        }

    }
    setShowAllDivisions = (e) => {

        this.setState({show_all_divisions: e.target.checked, page: 1})

        setTimeout(() =>
            this.getItems(undefined, false, 1), 700)
    }
    setShowSubDocs = (e) => {

        this.setState({show_sub_docs: e.target.checked, page: 1})

        setTimeout(() =>
            this.getItems(undefined, false, 1), 700)
    }
    setIsSlice = (e) => {

        this.setState({is_slice: e.target.checked, page: 1})

        setTimeout(() =>
            this.getItems(undefined, false, 1), 700)
    }

    startFacingMonitoring = (noClearData = false) => {
        window.postMessage({type: "startFacingMonitoring", noClearData})

    }
}

export default FacingMonitoringDocs